import { useEffect, useState, useRef, useDeferredValue } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProviders, editProvider, removeProvider } from 'modules/categories/categoriesSlice';
// eslint-disable-next-line max-len
import ScansProvidersComponent from 'modules/categories/scans/components/ScansProvidersComponent';
import { searchQueryMinLength, status } from 'constants/general';
import { useParams } from 'react-router-dom';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const ScansProvidersContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const { priceListId } = useParams();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [searchQuery, setSearchQuery] = useState('');
  const InitialQueryString = {
    priceListId,
    pageNumber: 1,
    pagesize: 10,
  };
  const [providersQueryString, setProvidersQueryString] = useState(InitialQueryString);
  const [isCreateProviderModalHidden, setIsCreateProviderModalHidden] = useState(true);
  const [filtersSelected, setFiltersSelected] = useState([]);

  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  const removeProviderState = useSelector(state => state.categories.removeProvider);
  const editProviderState = useSelector(state => state.categories.editProvider);
  const prevRemoveProviderState = useDeferredValue(removeProviderState.status);
  const prevEditProviderState = useDeferredValue(editProviderState.status);
  useEffect(() => {
    if (
      (status.SUCCESS === removeProviderState.status &&
        prevRemoveProviderState !== removeProviderState.status) ||
      (status.SUCCESS === editProviderState.status &&
        prevEditProviderState !== editProviderState.status)
    ) {
      setProvidersQueryString({ ...InitialQueryString });
    }
  }, [removeProviderState.status, editProviderState.status]);
  useEffect(() => {
    dispatch(fetchProviders(providersQueryString));
  }, [dispatch, providersQueryString]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################

  const handleOnToggleAddProvidersModel = isHidden => {
    setIsCreateProviderModalHidden(isHidden);
    if (isHidden) dispatch(fetchProviders(providersQueryString));
  };

  const handleInputFieldChange = () => {};

  const handleSearchInputChange = (searchTerm, reset) => {
    const queryString = {
      ...providersQueryString,
      pageNumber: 1,
      isShowMore: false,
    };
    if (searchTerm) queryString.searchterm = searchTerm;
    if (reset) delete queryString.searchterm;

    setProvidersQueryString(queryString);
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        handleSearchInputChange(value);
      }, 500);
    } else if (value.length < searchQueryMinLength && providersQueryString.searchterm)
      handleSearchInputChange(value, true);
  };

  const handleShowMoreClick = () => {
    const data = {
      ...providersQueryString,
    };
    data.pageNumber += 1;
    data.isShowMore = true;
    setProvidersQueryString(data);
  };

  const handleProviderDeactivate = rowDataPayload => {
    const { id, name, active } = rowDataPayload;
    const payload = {
      id,
      data: {
        priceListId,
        name,
        active: !active,
      },
    };
    dispatch(editProvider(payload));
  };

  const handleRemoveProvider = rowDataPayload => {
    const { id, priceListId } = rowDataPayload;
    const payload = {
      id,
      data: {
        priceListId,
      },
    };
    dispatch(removeProvider(payload));
  };

  const handleDropDownFilterChange = (fieldName, selectedValue) => {
    if (selectedValue) {
      setProvidersQueryString(prevValue => {
        const fieldsObj = { ...prevValue };
        fieldsObj[fieldName] = selectedValue;
        return fieldsObj;
      });
      setFiltersSelected(prevState => ({
        ...prevState,
        [fieldName]: true,
      }));
    } else {
      setProvidersQueryString(prevValue => {
        const fieldsObj = { ...prevValue };
        delete fieldsObj[fieldName];
        return fieldsObj;
      });
      setFiltersSelected(prevState => {
        const tempState = { ...prevState };
        delete tempState[fieldName];
        return tempState;
      });
    }
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <div>
      <ScansProvidersComponent
        isCreateProviderModalHidden={isCreateProviderModalHidden}
        setIsCreateProviderModalHidden={handleOnToggleAddProvidersModel}
        handleInputFieldChange={handleInputFieldChange}
        filtersSelected={filtersSelected}
        searchQuery={searchQuery}
        handleSearchBarInputChange={handleSearchBarInputChange}
        providersQueryString={providersQueryString}
        handleShowMoreClick={handleShowMoreClick}
        handleProviderDeactivate={handleProviderDeactivate}
        handleRemoveProvider={handleRemoveProvider}
        priceListId={priceListId}
        handleDropDownFilterChange={handleDropDownFilterChange}
        DropDownFilterChange={handleDropDownFilterChange}
      />
    </div>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

ScansProvidersContainer.propTypes = {};

ScansProvidersContainer.defaultProps = {};

export default ScansProvidersContainer;
